import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export default styled.div`
  color: ${color.WHITE};
  padding: 0.4375rem 0.3125rem 0.3125rem;
  text-transform: uppercase;
  font-size: 0.75rem;
  line-height: 0.625rem;
  width: auto;
  border-radius: 0.1875rem;
  display: inline-flex;
  justify-content: center;
  background: ${({ status, theme = {} }) => {
    switch (status) {
      case 'important':
        return color.REGAL
      case 'good':
        return color.AQUAMARINE
      case 'warn':
        return color.SAFFRON
      case 'bad':
        return color.WATERMELON
      case 'neutral':
      default:
        return color.SILVER
    }
  }};
`
